// TextInput.jsx
import React from "react";

const TextInput = ({ label, onChange }) => {
  return (
    <div className="form-group">
      <div className="floating-label">
        <input
          type="text"
          className="form-control"
          autoComplete="off"
          onChange={onChange}
        />
        <label>
          {label} <sup className="text-danger">*</sup>
        </label>
      </div>
      <p className="err text-danger"></p>
      <input type="hidden" />
    </div>
  );
};

export default TextInput;
